export default "__VITE_ASSET__b986c85e__"